export default {
    title: 'Ciclo Lunar',
    pageTitle: 'CICLO LUNAR',
    returnPersonalArea: 'Voltar para area pessoal',
    orbiaTrigger: 'Saiba mais sobre a Lua e o seu Mapa Astral perguntando ao Orbia!',
    featureIntroduction: '<b>{usuName}</b> acompanhe e fique em sintonia com as fases da lua.',

    phases: {
        'new-moon': 'Lua Nova',
        'full-moon': 'Lua Cheia',
        'gibous-moon': 'Lua Gibosa',
        'crescent-moon': 'Lua Nova Crescente',
        'waning-crescent-moon': 'Lua Balsâmica',
        'waning-gibous-moon': 'Lua Disseminadora',
        'last-quarter-moon': 'Lua Quarto Minguante',
        'waxing-crescent-moon': 'Lua Quarto Crescente',
    },

    mainTooltip: `
            <h3 style="margin:0px;padding-top:0px;margin-bottom:20px;"><i class="fa fa-question-circle text-purple"></i> Sobre o ciclo lunar</h3>
            <p>Ah, a misteriosa e inspiradora Lua...  ou Luna, Selene, Isis, Ártemis. São muitos os nomes e mitologias em torno desse satélite natural, que tem uma relação muito estreita com o nosso planeta, com os animais, seres humanos e com a natureza em geral. No mundo físico, a gravidade, as marés e a dinâmica dos fluidos são exemplos diretos de sua ação.</p>
            <p>O ritmo da lua dá o tom emocional do momento enquanto transita pelo Zodíaco, mudando de signo a cada 2 dias e meio. Podemos utilizar o ciclo lunar para guiar nosso próprio ritmo pessoal, usando seus posicionamentos como um guia para nossas atividades do cotidiano.</p>
            <p>Em nosso reino pessoal, suas fases aliam-se com a astrologia carregando propósitos e energias peculiares, que nos influenciam diariamente em diversas áreas como a tendência das massas, nossas emoções, aspectos de fertilidade, nutrição, no processo de interagir com o público, em nossos negócios, relacionamentos interpessoais, saúde, aparência, sono entre outras coisas.</p>
            <p>A Lua tem um papel importante em nossos ciclos de curta duração, em nossas flutuações emocionais e em nossos altos e baixos, criando uma dinâmica pessoal mensal, semanal, diária ou até mesmo horária.</p>
            <p>Muitas culturas antigas usavam os ciclos lunares para planejar as épocas de plantio e colheita, pesca, caça e até guerras! Com a industrialização e tecnologia, nos afastamos dos significados dos ciclos lunares, muitas vezes perdendo a oportunidade de planejar nossas vidas e tirar o máximo de benefícios das influências da Lua.</p>
            <p>A Lua Nova representa novos começos, o início de um novo ciclo mensal que traz novas possiblidades, assim, devemos aproveitar a Lua Nova para inícios, deixando claras nossas intenções. Já a Lua Cheia, representa o fechamento desse pequeno ciclo, onde iremos colher o que plantamos, além de tomar decisões e fazer ajustes necessários para começar de novo.</p>
        `,

    todayView: {
        title: 'Hoje',
        update: 'atualizar',
        readMore: 'Saiba mais',
        tooltipDate: '{date} próximo às {hour}',

        moonDuration: {
            hour: 'próximo às <b>{hour}</b>',
            description: '<b>{from}</b> a <b>{to}</b>',
            intermediateDescription: 'até dia <b>{dateTo}</b> próximo às <b>{hourTo}</b>'
        },

        aspects: {
            orb: 'Orbe',
            moon: 'Aspectos ativos da Lua',
            birthChart: 'Aspectos ativos em seu Mapa Astral',
        },

        content: {
            notLong: 'Falta pouco!',
            calendarLabel: 'Faltam {days} dias',
            calendarTitle: 'Se prepare para o próximo Ciclo da Lua!',

            firstSection: {
                close: 'Fechar',
                readMore: 'Leia mais',
                mostSensitiveOrgans: 'Orgãos mais sensíveis no momento',
                biorhythmPromotional: 'Você também pode saber mais sobre ciclos de curta duração analisando o seu <a href="{biorhythmUrl}">biorritmo</a>.'
            },

            accordionSection: {
                title: 'Influência da {moonPhase} no signo de {signName}'
            },

            threeSection: {
                challenges: 'Desafios',
                oportunities: 'Oportunidades',
                title: 'Outras Recomendações',
                about: {
                    mobile: 'Sobre',
                    desk: 'Sobre a Lua {phaseName}'
                }
            }
        }
    },

    futureView: {
        today: 'HOJE',
        title: 'Futuro',
        readMore: 'Mais sobre as Fases da Lua',
        buttonContent: 'Voltar para o dia de hoje',

        newCycle: {
            date: 'Dia {day} <br />de <br />{monthName}',
            inSign: '{moonPhase} <br />no Signo {sign}'
        },
    }
};